import React from 'react';
import './CSS/ImageDisplay.css';

const ImageDisplay = ({ imageUrl }) => {
  return <img src={process.env.PUBLIC_URL + imageUrl} alt="display" className="image" />;
};

export default ImageDisplay;
